import React, { FC } from 'react';

const TriangleIconLogo = () => (
  <svg
    width="33"
    height="17"
    viewBox="0 0 33 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5159 16.514L8.25988 8.26804L0.00488281 0.0220381L16.5049 0.0180381L33.0049 0.0140381L24.7609 8.26404L16.5159 16.514Z"
      fill="white"
    />
  </svg>
);

export default TriangleIconLogo;
